module.exports = __webpack_public_path__ + "static/img_1736-f819dfcfb7821f0c2473821a71f8fb21.webp";